var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDiskRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.4286C10.4286 12.4286 9.14286 13.7143 9.14286 15.2857C9.14286 16.8571 10.4286 18.1429 12 18.1429C13.5714 18.1429 14.8571 16.8571 14.8571 15.2857C14.8571 13.7143 13.5714 12.4286 12 12.4286ZM21.3348 6.7634L17.5893 3.01786C17.2277 2.65447 16.6786 2.42857 16.1116 2.42857H4.85714C3.27902 2.42857 2 3.70759 2 5.28572V19.5714C2 21.1496 3.27902 22.4286 4.85714 22.4286H19.1429C20.721 22.4286 22 21.1496 22 19.5714V8.31697C22 7.75 21.7723 7.2009 21.3348 6.7634ZM7.71429 4.57143H14.1429V8.14286H7.71429V4.57143ZM19.8571 19.5714C19.8571 19.9659 19.5373 20.2857 19.1429 20.2857H4.85714C4.46268 20.2857 4.14286 19.9659 4.14286 19.5714V5.28572C4.14286 4.89116 4.46268 4.57143 4.85714 4.57143H5.57143V9.21429C5.57143 9.80581 6.05134 10.2857 6.64286 10.2857H15.2143C15.808 10.2857 16.2857 9.80804 16.2857 9.21429V4.74464L19.779 8.23795C19.8304 8.28572 19.8571 8.35715 19.8571 8.42411V19.5714Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskRegular);
export default __webpack_public_path__ + "static/media/floppy-disk-regular.1f7744209b0fb1847340a8a08c3bc34f.svg";
export { ForwardRef as ReactComponent };